function SoberTrackData() {
    "use strict";

    this.TargetId = -1;
    this.RequestId = -1;
    this.ScheduledTestEditItem = null;
}
if (typeof exports !== 'undefined') {
    module.exports = SoberTrackData;
}